export const formatCurrency = (number, currency, locales) => parseFloat(number).toLocaleString(locales || 'it-IT', {
    style: 'currency',
    currency: currency
});

export const formatNumber = (number, decimal, locales) => (+(parseFloat(number).toFixed(decimal))).toLocaleString(locales || 'it-IT');